/**
 * Fix jQuery.load
 * https://stackoverflow.com/questions/37738732/jquery-3-0-url-indexof-error
 *
 * @param callback
 */
jQuery.fn.load = function(callback){ $(window).on("load", callback) };
